@if (professional; as prof) {
  <button
    type="button"
    (click)="onClick()"
    class="pro"
    [class.is-selected]="isSelected"
    [attr.aria-pressed]="isSelected"
    [attr.aria-label]="getFullName()">
    @if (prof.avatarUrl) {
      <img [src]="prof.avatarUrl" alt="" class="pro-avatar" loading="lazy" />
    } @else {
      <span class="pro-avatar pro-initials" [style.background-color]="getColor()" aria-hidden="true">
        {{ getInitials() }}
      </span>
    }

    <span class="pro-name">{{ getFullName() }}</span>

    <span class="pro-radio" aria-hidden="true">
      @if (isSelected) {
        <svg class="size-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
        </svg>
      }
    </span>
  </button>
}
